export default __webpack_public_path__ + "static/media/1536x600 guinea pigs1.b7c76c51.jpg";